import { defineStore } from "pinia";

export const useUserStore = defineStore("userStore", {
  state: () => ({
    user: {
      id: null,
      firstname: "",
      lastname: "",
      email: "",
      state: null,
      position: null,
      isTechnicalReviewer: 0,
      isVisualReviewer: 0,
      permissions: {},
    },
  }),
  actions: {
    setUser(userData) {
      this.user = userData;
    },
  },
  getters: {
    /** Reaktiver Permission-Check: $user.can('sections.edit') ist im store: useUserStore().can(...) */
    can(state) {
      return (key) => {
        const p = state.user?.permissions || {};
        return p[key] === 1 || p[key] === true;
      };
    },
  },
});
